window.frenzyProductGridWidgetCallBack = function () {
  const getHHTML =  document.querySelector('#frenzy_product_grid_widget');
  return getHHTML.innerHTML;
}
const frenzy_get_product_json = async function(url, html){
  jQuery.getJSON(url, function(product) {
    document.querySelectorAll('.FrenzyProductId_'+product.id).forEach(function(this_section){
      const getVariantID = this_section.getAttribute("data-variantid");
      const getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
      const max_price = product.price_max;
      const min_price = product.price_min;
      var compare_price = '';
      // var price = '<span> Starting at: </span>' + money_format_Frenzy(min_price, frenzy_shop_currency);
      var price = money_format_Frenzy(min_price, frenzy_shop_currency);
      this_section.querySelector('.frenzy_product_price_sale').innerHTML = '<span class="money">'+price+'</span>';
      this_section.querySelector('.frenzy_product_price_sale').classList.add('is-sale');
      this_section.querySelector('.frenzy_product_price_compare').style.display = 'none';
    });
  })
}
function frenzyGridSwatch (html,data){
  const allVariantSwatch = data?.all_options;
  let currVarID = data?.sku.split('_')[1];
  if(data.org_prod_url.includes('?variant=')){
    currVarID = data?.org_prod_url.split('?variant=')[1]
  }
  if(currVarID === '0'){
    currVarID = allVariantSwatch[0]?.variant_id;
  }
  const selectedStyle = (allVariantSwatch || []).find((x) => x.variant_id == currVarID);
  const findSelectedValue = (selectedStyle?.options || []).find((x) => x.name.toLowerCase() === 'style');
  const getConfigid = html.querySelector('.frenzy_product_item figure a').getAttribute('data-config_id');
  const getName = html.querySelector('.frenzy_product_item figure a').getAttribute('data-name');
  const getRequestid = html.querySelector('.frenzy_product_item figure a').getAttribute('data-request_id');
  const prodUrl = data?.org_prod_url.split('?variant=');
  let swatchArray = [];
  (allVariantSwatch || []).forEach((swatch) => {
    const getColorName = (swatch?.options || []).find((x) => x.name.toLowerCase() === 'style');
    const colorName = getColorName?.value;
    const colorImg = swatch?.org_image_url.split(' ');
    if(colorName){
      if (!swatchArray[colorName]) {
        swatchArray[colorName] = [];
      }
      swatchArray[colorName].push({
        id: swatch?.variant_id,
        img: colorImg[0],
      })
    }
  })
  let swatchHtml = '';
  if (swatchArray) {
    Object.entries(swatchArray).forEach(([colorName, clrArray],i) => {
      const getCurrSwatch = clrArray.find(v => v.id === currVarID);
      const isSelected = findSelectedValue?.value == colorName;
      let frenzyassetUrl = "https://banded.com/cdn/shop/files/";
      const colorImg = colorName.replaceAll(' ','-') + '.png';
      const finalImgURL = frenzyassetUrl + colorImg;
      const finalURL = prodUrl[0] + '?variant=' + clrArray[0].id;
      swatchHtml += `<div class="frenzy_swatch_item${isSelected ? ' is-selected' : ''}" key="${i}">
        <a aria-label="" style="background-image: url(${finalImgURL})" href="/products/${finalURL}" onclick="frenzyEventsClick(this)" data-sku="${data?.sku}" data-config_id="${getConfigid}" data-ab_test_id="null" data-name="${getName}" data-request_id="${getRequestid}"></a>
        </div>`;
    })
  }
  document.querySelectorAll('.frenzy_product_item[data-id="'+data?.sku+'"]').forEach((this_click) => {
    this_click.querySelector('.frenzy_product_item_detail .frenzy_product_swatch').innerHTML = swatchHtml;
  });
}
window.FrenzyProductGridChangeCallBack = function(html,data){
   html.querySelector('.frenzy_product_price_meta').classList.add("FrenzyProductId_"+data.product_id);
  if(data?.sale != "on sale"){
    if(html.querySelector('.frenzy_product_tags')){
      html.querySelector('.frenzy_product_tags .frenzy_tag.sale_tag').style.display = 'none';
    }
  }
  // if(data?.sale === "on sale"){
  //   html.querySelector('.frenzy_product_tags .frenzy_tag.sale_tag').style.display = 'block';
  //   const product_handle = data.org_prod_url.split("?");
  //   frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', html).then(frenzy_product_response => {return frenzy_product_response});
  // }
  const org_variant_min_price = data?.org_variant_min_price;
  if(org_variant_min_price && org_variant_min_price != null){
    html.querySelector('.frenzy_product_price_sale').innerHTML = '<span class="money">'+money_format_Frenzy(org_variant_min_price * 100, frenzy_shop_currency)+'</span>';
  }

  const product_labels = data?.st_new_arrivals_label;
  let frenzyNewHTML = '';
  let frenzyNewLabel = '';
  (product_labels || []).forEach(function(label){
    if(label == 'NEW' || label == 'New' || label == 'new'){
      frenzyNewLabel += label;
    }
  })
  if(frenzyNewLabel){
    frenzyNewHTML += '<span class="frenzy_tag new_tag">' + frenzyNewLabel + '</span>';
    html.querySelector('.frenzy_product_tags').insertAdjacentHTML('beforeend',frenzyNewHTML);
  }
  setTimeout(function(){
    frenzyGridSwatch(html,data);
  },300)

  // Badges display
  setTimeout(function(){
    if(data?.smf_badge != undefined){
      document.querySelectorAll('.frenzy_product_item[data-id="'+data?.sku+'"]').forEach((this_el) => {
        this_el.querySelector('.stamped-product-reviews-badge').innerHTML = data?.smf_badge[0];
        const reviewRating = this_el.querySelector('.stamped-product-reviews-badge').querySelector('.stamped-badge').getAttribute('data-rating');
        if(reviewRating > 0){
          this_el.querySelector('.stamped-product-reviews-badge .stamped-badge').insertAdjacentHTML('beforeend',(`<span class="stamped-badge-rating">${reviewRating}</span>`));
        }
      });
    }
  },300)
};

document.querySelectorAll(".frenzy_search_suggest").forEach(function (this_click) {
  this_click.addEventListener("click", function (event) {
    event.preventDefault(), event.stopImmediatePropagation();
    document.querySelector('body')?.scrollIntoView({ behavior: "smooth" });
  })
})
window.frenzyAnimationCallBack = () => {
  let frenzyUpdatePlaceholder = '';
  const gridLength = 24;
  frenzyUpdatePlaceholder += '<div class="frenzy_collection_page_loader_content">';
  frenzyUpdatePlaceholder += '<div class="frenzy_container">';
  frenzyUpdatePlaceholder += '<div class="frenzy_topbar_loader_content">';
  frenzyUpdatePlaceholder += '<div class="frenzy_filter_loader_content "></div>';
  frenzyUpdatePlaceholder += '<div class="frenzy_sorting_loader_content"></div>';
  frenzyUpdatePlaceholder += '<div class="frenzy_empty_loader_content"></div>';
  frenzyUpdatePlaceholder += '<div class="frenzy_orientation_loader_content">';
  frenzyUpdatePlaceholder += '<span></span>';
  frenzyUpdatePlaceholder += '<span></span>';
  frenzyUpdatePlaceholder += '<span></span>';
  frenzyUpdatePlaceholder += '</div>';
  frenzyUpdatePlaceholder += '</div>';
  frenzyUpdatePlaceholder += '<div class="frenzy_content_loader_row">';
  frenzyUpdatePlaceholder += '<div class="frenzy_sidebar_loader_content"><div class="frenzy_side_bar_filter_loader_content"><div class="frenzy_filter_title_loader"></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div></div><div class="frenzy_side_bar_filter_loader_content color_filter_loader"><div class="frenzy_filter_title_loader"></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div></div></div>';
  frenzyUpdatePlaceholder += '<div class="frenzy_loader_row loader_grid_3">';
  for(var i = 1; i <= gridLength; i++ ){
    frenzyUpdatePlaceholder += '<div class="frenzy_loader_grid">';
    frenzyUpdatePlaceholder += '<figure>';
    frenzyUpdatePlaceholder += '<img src="https://cdn.frenzyai.click/plugin/placeholder.png" />';
    frenzyUpdatePlaceholder += '</figure>';
    frenzyUpdatePlaceholder += '<p></p>';
    frenzyUpdatePlaceholder += '<span></span>';
    frenzyUpdatePlaceholder += '</div>';
  }
  frenzyUpdatePlaceholder += '</div>';
  frenzyUpdatePlaceholder += '</div>';
  frenzyUpdatePlaceholder += '</div>';
  frenzyUpdatePlaceholder += '</div>';
  return frenzyUpdatePlaceholder;
}

window.frenzySwiperSliderCallBack = (swiperContainer,loop) => {
      var swiper = new Swiper(
      swiperContainer + " .frenzy_recommendation_contain",
      {
          slidesPerView: "auto",
          initialSlide: 4,
          freeMode: true,
          spaceBetween: 0,
          // centeredSlides: true,
          loop: true,
          watchOverflow: true,
          a11y: true,
          allowTouchMove: true,
          loopPreventsSliding: true,
          keyboard: {
              enabled: true,
          },
          navigation: {
              nextEl: swiperContainer + " .swiper-button-next",
              prevEl: swiperContainer + " .swiper-button-prev",
          },
          scrollbar: {
              hide: false,
              el: swiperContainer + " .swiper-scrollbar",
              draggable: true,
          },
          paginationClickable: true,
      }
  );
}


